<template>
	<div>
		<div class="popBoxBg" v-show="show"></div>
		<div class="popBox" v-show="show">
			<div class="inner">
				<!-- 打印中 -->
				<div class="print-ing">
					<div class="title">
						正在打印中，请稍后...
					</div>
					<div class="p">
						第1/15页
					</div>
					<div class="equipment">
						<img src="../../assets/equipment.png" class="equipment-img">
						
						
						<img src="../../assets/print-gif.gif" class="gif">
						
					</div>
				</div>
				<div class="button-group">
					<div class="button-blue fcc" @click="closePopTips">
						<img src="../../assets/icon/icon-return.png" >
						<span>返回</span>
						<span>（{{time321}}s）</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'q-pop-print-ing',
		props: {
			numTips:{
				type:[String,Number],
				default:null
			}
		},
		data() {
			return {
				timer:null,
				show:true,
				time321:30
			}
		},
	
		
		mounted() {
			var that = this;
			that.timer = setInterval(function() {
				that.time321--
				if (that.time321 < 1) {
					clearInterval(that.timer)
					that.closePopTips()
				}
			}, 1000)
		},
		methods: {
			closePopTips() {
				this.show=false
				clearInterval(this.timer);
			},
		},
		beforeDestroy() {
			clearInterval(this.timer);
		}
		
	}
</script>

<style scoped lang="less">
	
		.title{
			font-size: 45px;
			padding-top: 50px;
			font-weight: 800;
			color: #000000;
			line-height: 73px;
		}
		.gif{
			position: absolute;
				left: 293px;
				top: 93px;
		}
		
		.equipment-img{
			display: block;
			width: 100%;
			height: 100%;
		}
		
		.equipment{
			width: 167px;
			height: 433px;
			position: absolute;
			left: 124px;
			top: 260px;
		}
	
		.print-ing{
			.equipment{
				&:before{
					content: "";
					display: block;
					background: url(../../assets/id-tips.png) no-repeat;
					width: 472px;
					height: 310px;
					position: absolute;
					top: 0px;
					left: 77px;
				}
			}
			
		}
		.p{
			font-size: 38px;
			color: #828282;
			padding: 25px 0;
		}
		
		.button-group{
			position: absolute;
			right: 47px;
			bottom: 54px;
		}
		.inner{
			padding: 0 47px 0;
			text-align: center;
			
			
			
			
		}
		
		
</style>
